import $ from 'jquery'

export let ActionType = {
  CHANGE_ORIENTATION: 'CHANGE_ORIENTATION',
  DISPLAY_DETAILS: 'DISPLAY_DETAILS',
  DISPLAY_DOCUMENT_ERRORS: 'DISPLAY_DOCUMENT_ERRORS',
  DISPLAY_ERROR: 'DISPLAY_ERROR',
  DISPLAY_TOOL_TIP: 'DISPLAY_TOOL_TIP',
  FILTER_RESET: 'FILTER_RESET',
  HIGHLIGHT_ELEMENT: 'HIGHLIGHT_ELEMENT',
  HIGHLIGHT_LEVEL: 'HIGHLIGHT_LEVEL',
  HIGHLIGHT_HITAREA: 'HIGHLIGHT_HITAREA',
  HIGHLIGHT_UNIT: 'HIGHLIGHT_UNIT',
  RECEIVE_AND_APPLY_FILTER_CHANGE: 'RECEIVE_AND_APPLY_FILTER_CHANGE',
  RECEIVE_FLOOR_PICKER: 'RECEIVE_FLOOR_PICKER',
  RECEIVE_MAP_DOCUMENT: 'RECEIVE_MAP_DOCUMENT',
  RECEIVE_UNITS: 'RECEIVE_UNITS',
  REQUEST_FLOOR_PICKER: 'REQUEST_FLOOR_PICKER',
  REQUEST_MAP_DOCUMENT: 'REQUEST_MAP_DOCUMENT',
  REQUEST_UNITS: 'REQUEST_UNITS',
  SET_DEFAULTS: 'SET_DEFAULTS',
  SET_FLOOR_PICKER: 'SET_FLOOR_PICKER',
  SET_UNIT_MAP: 'SET_UNIT_MAP',
  SET_UNIT_MAP_BACKGROUND_COLOR: 'SET_UNIT_MAP_BACKGROUND_COLOR',
  SET_WINDOW_TITLE: 'SET_WINDOW_TITLE'
}

export function changeOrientation () {
  return {
    type: ActionType.CHANGE_ORIENTATION
  }
}

export function setFloorPicker (unitmap) {
  return {
    type: ActionType.SET_FLOOR_PICKER,
    unitmap
  }
}

export function setUnitMap (unitmap) {
  return {
    type: ActionType.SET_UNIT_MAP,
    unitmap
  }
}

export function requestFloorPicker (file) {
  return {
    type: ActionType.REQUEST_FLOOR_PICKER,
    file
  }
}

export function requestMapDocument (file) {
  return {
    type: ActionType.REQUEST_MAP_DOCUMENT,
    file
  }
}

export function requestUnits (url) {
  return {
    type: ActionType.REQUEST_UNITS,
    url
  }
}

export function setWindowTitle (title) {
  return {
    type: ActionType.SET_WINDOW_TITLE,
    title
  }
}

export function setUnitMapBackgroundColor (color) {
  return {
    type: ActionType.SET_UNIT_MAP_BACKGROUND_COLOR,
    color
  }
}

export function setDefaultFilters (config, units) {
  return {
    type: ActionType.SET_DEFAULTS,
    config,
    units
  }
}

export function highlightElement (element) {
  return {
    type: ActionType.HIGHLIGHT_ELEMENT,
    element
  }
}

export function highlightLevel (level) {
  return {
    type: ActionType.HIGHLIGHT_LEVEL,
    level
  }
}

export function highlightUnit (unit) {
  return {
    type: ActionType.HIGHLIGHT_UNIT,
    unit
  }
}

export function highlightHitArea (hitArea) {
  return {
    type: ActionType.HIGHLIGHT_HITAREA,
    hitArea
  }
}

export function displayDetails (unit) {
  return {
    type: ActionType.DISPLAY_DETAILS,
    unit
  }
}

export function displayDocumentErrors (display) {
  return {
    type: ActionType.DISPLAY_DOCUMENT_ERRORS,
    display
  }
}

export function displayError (message) {
  return {
    type: ActionType.DISPLAY_ERROR,
    message
  }
}

export function displayToolTip (unit, x, y) {
  return {
    type: ActionType.DISPLAY_TOOL_TIP,
    unit,
    x,
    y
  }
}

export function filterReset () {
  return {
    type: ActionType.FILTER_RESET
  }
}

export function receiveFloorPicker (file, data, errors) {
  return {
    type: ActionType.RECEIVE_FLOOR_PICKER,
    file,
    data,
    errors,
    receivedAt: Date.now()
  }
}

export function receiveMapDocument (file, data, errors) {
  return {
    type: ActionType.RECEIVE_MAP_DOCUMENT,
    file,
    data,
    errors,
    receivedAt: Date.now()
  }
}

export function receiveUnits (url, data, errors) {
  return {
    type: ActionType.RECEIVE_UNITS,
    url,
    data,
    errors,
    receivedAt: Date.now()
  }
}

export function receiveAndApplyFilterChange (valueFor, value) {
  return {
    type: ActionType.RECEIVE_AND_APPLY_FILTER_CHANGE,
    valueFor,
    value,
    receivedAt: Date.now()
  }
}

export function fetchFloorPicker (file) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestFloorPicker(file))

      $.get(file, function (response) {
        resolve({
          document: response,
          errors: []
        })
        dispatch(receiveFloorPicker(file, response, []))
      }, 'json')
    })
  }
}

export function fetchMapDocument (file) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestMapDocument(file))

      $.get(file, function (response) {
        resolve({
          document: response,
          errors: []
        })
        dispatch(receiveMapDocument(file, response, []))
        dispatch(setWindowTitle(file))
      }, 'json')
    })
  }
}

export function fetchUnits (url) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestUnits(url))
      $.get(url, function (response) {
        resolve({
          document: response,
          errors: []
        })
        dispatch(receiveUnits(url, response, []))
      }, 'json')
    })
  }
}
